import React from "react";
import t from "common/i18n";
import { Combobox } from "@cld/combobox";
import { ETHNICITY_OPTIONS } from "../../data/consts";
import { useFilterParams } from "../../selectors";
import { getSelectedItemByValue } from "../../utils";
import { SectionBox } from "./Filters.styles";


export default ({ handleSearch }) => {
	const { ethnicity } = useFilterParams();
	const selectedItem = getSelectedItemByValue(ethnicity, ETHNICITY_OPTIONS);
	const options = ETHNICITY_OPTIONS.map((value: string) => ({ label: t(`istock.filters.ethnicity.${value}`), value }));
	
	const filterChange = (item) => {
		handleSearch({
			filters: {
				ethnicity: item?.value
			}
		});
	};
	return (<SectionBox data-test="ethnicity-section">
		<label>{t("istock.filters.ethnicity.label")}</label>
		<Combobox
			size="md"
			isSearchable={false}
			placeholder={t("istock.select")}
			options={options}
			value={selectedItem}
			onChange={filterChange}
			menuPlacement="top"
		/>
	</SectionBox>);
};
